<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @handleOpen="handleOpen"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div
          :class="`${
            businesses.length > 2
              ? `col-md-5 col-lg-5 col-xl-5`
              : `col-md-12 col-xl-12`
          }`"
        >
          <fg-input
            :label="`${$t('common_words.name')}: *`"
            class="shadow-sm required-name"
            type="text"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div v-if="businesses.length > 2" class="col-md-7 col-lg-7 col-xl-7">
          <div class="form-group has-label">
            <label>{{ $t('common_words.companies2') }}: *</label>
            <br />
            <el-select
              collapse-tags
              @change="selectAllFromSelect('model.business_id', businesses)"
              clearable
              multiple
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-md-12 col-lg-12 col-xl-12">
          <div class="form-group has-label">
            <label>{{ $t('common_words.description') }}: </label>
            <el-input
              :maxlength="300"
              show-word-limit
              class="shadow-sm required-description"
              type="textarea"
              :rows="3"
              v-model="model.description"
              placeholder="..."
            >
            </el-input>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-rate',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [MixinDialog, MixinForm, MixinPermissions, MixinValidations],
  data() {
    return {
      businesses: [],
      model: {
        name: null,
        description: null,
        business_id: [],
        route: null,
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    handleOpen() {
      if (!this.model.isEdit) {
        this.model.business_id = this.selectElementsAsignFromModel(
          1,
          this.model.business_id,
          this.businesses
        );
      }
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.name)) {
            return this.validationInputsRequired('name');
          } else if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const { id, name, description, businesses } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        id,
        name,
        description,
        business_id: businesses.map((business) => business.id),
        isEdit: true,
      };
      this.errors.clear();
      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('businesses/only')])
        .then((response) => {
          const [response_businesses] = response;
          this.businesses = this.concatAll(response_businesses.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
  },
};
</script>
